// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UBuF","right":"styles_right__3dv5f"};